import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container mt-4 h-100 w-100 availability-calendar" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-header bg-primary text-white" }
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = {
  class: "mb-3",
  title: "Applies to the dates you stage below - click Save to submit them together."
}
const _hoisted_9 = ["title"]
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "table table-bordered text-center calendar-table" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "small"
}
const _hoisted_14 = {
  key: 0,
  title: "Part of a recurring series"
}
const _hoisted_15 = {
  key: 1,
  title: "Partial-day non-availability"
}
const _hoisted_16 = {
  key: 2,
  title: "Pending approval"
}
const _hoisted_17 = {
  key: 0,
  class: "d-flex align-items-center gap-2 mt-3 flex-wrap"
}
const _hoisted_18 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NonAvailabilityGroupEditModal = _resolveComponent("NonAvailabilityGroupEditModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, "Availability - " + _toDisplayString($props.officerName), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-outline-secondary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.previousMonth && $options.previousMonth(...args)))
          }, "< Prev"),
          _createElementVNode("strong", null, _toDisplayString($options.monthLabel), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-outline-secondary",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.nextMonth && $options.nextMonth(...args)))
          }, "Next >")
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[10] || (_cache[10] = _createElementVNode("label", {
            class: "form-label me-2",
            title: "If set, clicking an available date marks every matching weekday up to this date as unavailable together."
          }, " Repeat weekly until ", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "date",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.repeatUntil) = $event)),
            class: "form-control form-control-sm d-inline-block availability-control",
            style: {"width":"160px"}
          }, null, 512), [
            [_vModelText, $data.repeatUntil]
          ]),
          ($data.repeatUntil)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-sm btn-link",
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($data.repeatUntil = ''))
              }, "Clear"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.selectedTypeId) = $event)),
            class: "form-select form-select-sm d-inline-block availability-control",
            style: {"width":"220px"},
            title: $options.selectedTypeRequiresApproval ? 'Submitted for approval - the officer stays available for scheduling until it\'s approved.' : ''
          }, [
            _cache[11] || (_cache[11] = _createElementVNode("option", {
              value: null,
              disabled: ""
            }, "Select type", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.nonAvailabilityTypes, (type) => {
              return (_openBlock(), _createElementBlock("option", {
                key: type.nonAvailabilityTypeId,
                value: type.nonAvailabilityTypeId
              }, _toDisplayString(type.name), 9, _hoisted_10))
            }), 128))
          ], 8, _hoisted_9), [
            [
              _vModelSelect,
              $data.selectedTypeId,
              void 0,
              { number: true }
            ]
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.reason) = $event)),
            class: "form-control form-control-sm d-inline-block ms-2 availability-control",
            style: {"width":"auto"},
            placeholder: "Reason / remarks (optional)"
          }, null, 512), [
            [_vModelText, $data.reason]
          ])
        ]),
        _createElementVNode("table", _hoisted_11, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.weekdayLabels, (label) => {
                return (_openBlock(), _createElementBlock("th", { key: label }, _toDisplayString(label), 1))
              }), 128))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.calendarWeeks, (week, wIdx) => {
              return (_openBlock(), _createElementBlock("tr", { key: wIdx }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(week, (cell) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: cell.key,
                    class: _normalizeClass(["calendar-cell", $options.cellClass(cell)]),
                    onClick: ($event: any) => ($options.onCellClick(cell))
                  }, [
                    _createElementVNode("div", null, _toDisplayString(cell.day), 1),
                    (cell.record)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          (cell.record.recurrenceGroupId)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, "🔁"))
                            : _createCommentVNode("", true),
                          ($options.isPartialDay(cell.record))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, "🕑"))
                            : _createCommentVNode("", true),
                          (cell.record.status === 'Pending')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, "⏳"))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_12))
                }), 128))
              ]))
            }), 128))
          ])
        ]),
        ($data.stagedDates.size > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("span", null, _toDisplayString($data.stagedDates.size) + " date(s) selected", 1),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-primary",
                disabled: $data.loading || !$data.selectedTypeId,
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($options.saveStaged && $options.saveStaged(...args)))
              }, "Save", 8, _hoisted_18),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-outline-secondary",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($options.clearSelection && $options.clearSelection(...args)))
              }, "Clear selection")
            ]))
          : _createCommentVNode("", true),
        ($data.message)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["alert mt-3", $data.messageType]),
              role: "alert"
            }, _toDisplayString($data.message), 3))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-outline-secondary mt-3",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('close')))
        }, "Close")
      ])
    ]),
    ($data.editingGroupId)
      ? (_openBlock(), _createBlock(_component_NonAvailabilityGroupEditModal, {
          key: 0,
          "base-url": $props.baseUrl,
          "recurrence-group-id": $data.editingGroupId,
          "all-records": $data.records,
          "non-availability-types": $data.nonAvailabilityTypes,
          onClose: _cache[9] || (_cache[9] = ($event: any) => ($data.editingGroupId = null)),
          onSaved: $options.onGroupSaved
        }, null, 8, ["base-url", "recurrence-group-id", "all-records", "non-availability-types", "onSaved"]))
      : _createCommentVNode("", true)
  ]))
}